module.exports = __webpack_public_path__ + "static/media/code.5b08e348.svg";